/* 🤖 this file was generated by svg-to-ts */
export const matIconHighlight: {
  name: 'highlight';
  data: string;
} = {
  name: 'highlight',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m6 14 3 3v5h6v-5l3-3V9H6v5zm2-3h8v2.17l-3 3V20h-2v-3.83l-3-3V11zm3-9h2v3h-2zM3.502 5.874 4.916 4.46l2.122 2.12-1.414 1.415zm13.458.708 2.123-2.12 1.413 1.416-2.123 2.12z"/></svg>`
};
